import { createToaster } from '@chakra-ui/react';

export { toaster } from '@halo/ui-react';

export const toasterOriginal: ReturnType<typeof createToaster> = createToaster({
  placement: 'top-end',
  max: 5,
  pauseOnPageIdle: true,
});

export const notification: ReturnType<typeof createToaster> = createToaster({
  placement: 'top-end',
  max: 5,
  pauseOnPageIdle: true,
});

export const toasterCopy: ReturnType<typeof createToaster> = createToaster({
  placement: 'bottom',
  offsets: '80px',
  max: 5,
  pauseOnPageIdle: true,
});
